import { render, staticRenderFns } from "./AddOrChangePasswordAdmin.vue?vue&type=template&id=1925565c"
import script from "./AddOrChangePasswordAdmin.vue?vue&type=script&lang=js"
export * from "./AddOrChangePasswordAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports